export default __webpack_public_path__ + "static/media/pagePhoto5.a5713564.png";